import r, { PureComponent as t, useReducer as e, useRef as n, useCallback as o } from "react";
var c = function (r) {
    var t, e;
    function n(t) {
      var e;
      return (e = r.call(this, t) || this).state = {
        hasError: !1,
        error: null
      }, e;
    }
    e = r, (t = n).prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e, n.getDerivedStateFromError = function (r) {
      return {
        hasError: !0,
        error: r
      };
    };
    var o = n.prototype;
    return o.componentDidCatch = function (r, t) {
      return this.props.onDidCatch(r, t);
    }, o.render = function () {
      var r = this.state,
        t = this.props,
        e = t.render,
        n = t.children,
        o = t.renderError;
      return r.hasError ? o ? o({
        error: r.error
      }) : null : e ? e() : n || null;
    }, n;
  }(t),
  u = function (r, t) {
    switch (t.type) {
      case "catch":
        return {
          didCatch: !0,
          error: t.error
        };
      case "reset":
        return {
          didCatch: !1,
          error: null
        };
      default:
        return r;
    }
  };
function a(t) {
  var a = e(u, {
      didCatch: !1,
      error: null
    }),
    i = a[0],
    d = a[1],
    h = n(null);
  function l() {
    return e = function (r, e) {
      d({
        type: "catch",
        error: r
      }), t && t.onDidCatch && t.onDidCatch(r, e);
    }, function (t) {
      return r.createElement(c, {
        onDidCatch: e,
        children: t.children,
        render: t.render,
        renderError: t.renderError
      });
    };
    var e;
  }
  var p,
    s = o(function () {
      h.current = l(), d({
        type: "reset"
      });
    }, []);
  return {
    ErrorBoundary: (p = h.current, null !== p ? p : (h.current = l(), h.current)),
    didCatch: i.didCatch,
    error: i.error,
    reset: s
  };
}
export default a;
export { a as useErrorBoundary };